import { render } from "./ContentContainer.vue?vue&type=template&id=3f02f438"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3f02f438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f02f438', script)) {
    api.reload('3f02f438', script)
  }
  
  module.hot.accept("./ContentContainer.vue?vue&type=template&id=3f02f438", () => {
    api.rerender('3f02f438', render)
  })

}

script.__file = "src/components/ContentContainer.vue"

export default script